import { useEffect, useRef, useState } from 'react'

import { Scrollbar, Typography } from '@it-incubator/ui-kit'

import s from './toc.module.scss'

import { TocNode } from './toc-node'
import { NodeData } from './toc-node.types'

type Props = {
  tocMap: NodeData
}
export const TableOfContents = ({ tocMap }: Props) => {
  const [currentHeading, setCurrentHeading] = useState('')
  const headingsObserverRef = useRef<IntersectionObserver | null>(null)

  useEffect(() => {
    const setCurrent: IntersectionObserverCallback = entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          setCurrentHeading(entry.target.id)
          break
        }
      }
    }

    const observerOptions: IntersectionObserverInit = {
      // Negative top margin accounts for `scroll-margin`.
      // Negative bottom margin means heading needs to be towards top of viewport to trigger intersection.
      rootMargin: '-60px 0% -40%',
      threshold: 1,
    }

    const observer = new IntersectionObserver(setCurrent, observerOptions)

    setTimeout(() => {
      document
        .querySelectorAll('article :is(h2,h3,h4)')
        .forEach(heading => observer.observe(heading))
    }, 100)

    headingsObserverRef.current = observer

    return () => {
      observer.disconnect()
    }
  }, [tocMap])

  return (
    <aside className={s.toc}>
      <Scrollbar className={s.scroll} type={'hover'}>
        <Typography.Subtitle2 mb={'13px'} ml={'8px'} mt={'19px'}>
          Содержание:
        </Typography.Subtitle2>
        <TocNode currentHeading={currentHeading} data={tocMap} depth={0} />
      </Scrollbar>
    </aside>
  )
}
